import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import AppTokenIcon from './AppTokenIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppTokenIconRow',
    props: {
        tokens: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, {
                class: "flex-nowrap fill-height justify-start justify-sm-end ma-0",
                align: "center"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tokens, (i, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(['d-flex align-center', { 'ml-n5': index != 0 }])
                        }, [
                            _createVNode(AppTokenIcon, {
                                tokenIcon: i,
                                "img-size": "40"
                            }, null, 8, ["tokenIcon"])
                        ], 2));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
